(function () {

    'use strict';

    if (typeof window === 'undefined') {
        const DataSourceIds = require('./enums/dataSourceIds.js');
        module.exports = {
            [DataSourceIds.COMPANIES]: require('./dataSources/companies.js'),
            [DataSourceIds.CROSS_CHANNEL_PUBLIC_PRESENCE_DATA]: require('./dataSources/crossChannelPublicPresence.js'),
            [DataSourceIds.TWITTER_PUBLIC_PRESENCE_DATA]: require('./dataSources/twitterPublicPresence.js'),
            [DataSourceIds.FACEBOOK_PUBLIC_PRESENCE_DATA]: require('./dataSources/facebookPublicPresence.js'),
            [DataSourceIds.INSTAGRAM_PUBLIC_PRESENCE_DATA]: require('./dataSources/instagramPublicPresence.js'),
            [DataSourceIds.YOUTUBE_PUBLIC_PRESENCE_DATA]: require('./dataSources/youtubePublicPresence.js'),
            [DataSourceIds.TIKTOK_PUBLIC_PRESENCE_DATA]: require('./dataSources/tiktokPublicPresence.js'),
            [DataSourceIds.CROSS_CHANNEL_PUBLIC_POST_DATA]: require('./dataSources/crossChannelPublicPost.js'),
            [DataSourceIds.TWITTER_PUBLIC_POST_DATA]: require('./dataSources/twitterPublicPost.js'),
            [DataSourceIds.FACEBOOK_PUBLIC_POST_DATA]: require('./dataSources/facebookPublicPost.js'),
            [DataSourceIds.INSTAGRAM_PUBLIC_POST_DATA]: require('./dataSources/instagramPublicPost.js'),
            [DataSourceIds.YOUTUBE_PUBLIC_POST_DATA]: require('./dataSources/youtubePublicPost.js'),
            [DataSourceIds.TIKTOK_PUBLIC_POST_DATA]: require('./dataSources/tiktokPublicPost.js'),
            [DataSourceIds.TIKTOK_PRIVATE_PRESENCE_DATA]: require('./dataSources/tiktokPrivatePresence.js'),
            [DataSourceIds.INSTAGRAM_PRIVATE_POST_DATA]: require('./dataSources/instagramPrivatePost.js'),
            [DataSourceIds.INSTAGRAM_PRIVATE_STORY_FRAME_DATA]: require('./dataSources/instagramPrivateStoryFrame.js'),
            [DataSourceIds.LINKEDIN_PRIVATE_POST_DATA]: require('./dataSources/linkedInPrivatePost.js'),
            [DataSourceIds.FACEBOOK_PRIVATE_POST_DATA]: require('./dataSources/facebookPrivatePost.js'),
            [DataSourceIds.TIKTOK_PRIVATE_POST_DATA]: require('./dataSources/tiktokPrivatePost.js'),
            [DataSourceIds.CROSS_CHANNEL_INSIGHTS_POST_DATA]: require('./dataSources/crossChannelInsightsPost.js'),
            [DataSourceIds.LISTENING_QUERY_SEARCH]: require('./dataSources/listeningQuerySearch.js'),
            [DataSourceIds.QUID_TOPICS]: require('./dataSources/quidTopics.js'),
            [DataSourceIds.LISTENING_QUERY_SEARCH_RECOMMENDATIONS]: require('./dataSources/listeningQuerySearchRecommendations.js')
        };

    } else {
        RivalIQ.module('metrics.new', function (metricsNew) {
            const DataSourceIds = RivalIQ.metrics.new.enums.DataSourceIds;
            const dataSources = RivalIQ.metrics.new.dataSources;
            metricsNew.DataSources = {
                [DataSourceIds.COMPANIES]: dataSources.Companies,
                [DataSourceIds.CROSS_CHANNEL_PUBLIC_PRESENCE_DATA]: dataSources.CrossChannelPublicPresence,
                [DataSourceIds.TWITTER_PUBLIC_PRESENCE_DATA]: dataSources.TwitterPublicPresence,
                [DataSourceIds.FACEBOOK_PUBLIC_PRESENCE_DATA]: dataSources.FacebookPublicPresence,
                [DataSourceIds.INSTAGRAM_PUBLIC_PRESENCE_DATA]: dataSources.InstagramPublicPresence,
                [DataSourceIds.YOUTUBE_PUBLIC_PRESENCE_DATA]: dataSources.YoutubePublicPresence,
                [DataSourceIds.TIKTOK_PUBLIC_PRESENCE_DATA]: dataSources.TiktokPublicPresence,
                [DataSourceIds.CROSS_CHANNEL_PUBLIC_POST_DATA]: dataSources.CrossChannelPublicPost,
                [DataSourceIds.TWITTER_PUBLIC_POST_DATA]: dataSources.TwitterPublicPost,
                [DataSourceIds.FACEBOOK_PUBLIC_POST_DATA]: dataSources.FacebookPublicPost,
                [DataSourceIds.INSTAGRAM_PUBLIC_POST_DATA]: dataSources.InstagramPublicPost,
                [DataSourceIds.YOUTUBE_PUBLIC_POST_DATA]: dataSources.YoutubePublicPost,
                [DataSourceIds.TIKTOK_PUBLIC_POST_DATA]: dataSources.TiktokPublicPost,
                [DataSourceIds.TIKTOK_PRIVATE_PRESENCE_DATA]: dataSources.TiktokPrivatePresence,
                [DataSourceIds.INSTAGRAM_PRIVATE_POST_DATA]: dataSources.InstagramPrivatePost,
                [DataSourceIds.INSTAGRAM_PRIVATE_STORY_FRAME_DATA]: dataSources.InstagramPrivateStoryFrame,
                [DataSourceIds.LINKEDIN_PRIVATE_POST_DATA]: dataSources.LinkedInPrivatePost,
                [DataSourceIds.FACEBOOK_PRIVATE_POST_DATA]: dataSources.FacebookPrivatePost,
                [DataSourceIds.TIKTOK_PRIVATE_POST_DATA]: dataSources.TiktokPrivatePost,
                [DataSourceIds.CROSS_CHANNEL_INSIGHTS_POST_DATA]: dataSources.CrossChannelInsightsPost,
                [DataSourceIds.LISTENING_QUERY_SEARCH]: dataSources.ListeningQuerySearch,
                [DataSourceIds.QUID_TOPICS]: dataSources.QuidTopics,
                [DataSourceIds.LISTENING_QUERY_SEARCH_RECOMMENDATIONS]: dataSources.ListeningQuerySearchRecommendations
            };
        });
    }
})();
